import {
    COMMISSIONS_GET_POLICY_BEGIN,
    COMMISSIONS_GET_POLICY_SUCCESS,
    COMMISSIONS_GET_POLICY_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case COMMISSIONS_GET_POLICY_BEGIN:
        return {
          ...state,
          policies: {
            ...state.policies, 
          getPolicySuccess:false,
          },
          commissionPolicy: {
            ...state.commissionPolicy, 
          }
        }
      case COMMISSIONS_GET_POLICY_SUCCESS:
        return {
          ...state,
          policies: {
            ...state.policies, 
            basicInformation: {
              ...state.policies.basicInformation,
              comission_policy_name: action.data.data[0].comission_policy_name,
              comission_policy_state: action.data.data[0].comission_policy_state,
              comission_policy_state_id: action.data.data[0].comission_policy_state_id,
            },
          getPolicySuccess:true,
          },
          commissionPolicy:  {
            ...state.commissionPolicy, 
            ...action.data,
          }
        }
      case COMMISSIONS_GET_POLICY_FAILURE:
        return {
          ...state,
          policies: {
            ...state.policies, 
          getPolicySuccess:false,
          },
          commissionPolicy: {
            ...state.commissionPolicy, 
          }
        }
      default:
        return state
    }
  }